import { Injectable } from '@angular/core';
import FingerprintJS from '@fingerprintjs/fingerprintjs'

@Injectable({
  providedIn: 'root'
})
export class ConnectionTrackerService {

  private systemBrowserId: string | null = null;
  private tabId: string | null = null;

  constructor() {
    if (!sessionStorage.getItem('tabId')) {
      this.tabId = this.generateTabId();
      sessionStorage.setItem('tabId', this.tabId);
    } else {
      this.tabId = sessionStorage.getItem('tabId');
    }
    this.initializeFingerprint();
  }

  async initializeFingerprint() {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    this.systemBrowserId = result.visitorId;
  }

  // Generate a random UUID for tab ID
  private generateTabId(): string {
    return crypto.randomUUID();
  }

  getSystemBrowserId(): string | null {
    return this.systemBrowserId;
  }

  getTabId(): string | null {
    return this.tabId;
  }
}
